import type {
  OrganizationSearchEstablishment,
  OrganizationSearchResult,
} from '../types/organization-search-result.type';

export const resolveHeadOfficeEstablishment = (
  result: Readonly<OrganizationSearchResult>,
): OrganizationSearchEstablishment | undefined =>
  result.matching_etablissements?.find(
    (establishment) => establishment.est_siege,
  ) ??
  result.siege ??
  undefined;
